import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, Input, useInfinityScrollObserver } from '@nest/uikit-react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo, useState } from 'react';
import { useTerminalClient } from '../client-rpc-router';

export function HandlingUnitSelectDialog({
	open,
	onOpenChange,
	onSelect
}: {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	onSelect: (value: { id: number; code: string }) => void;
}) {
	const client = useTerminalClient();
	const [filter, setFilter] = useState('');

	const query = useInfiniteQuery({
		queryKey: ['handling-units', filter],
		queryFn: async ({ pageParam = 0 }) => {
			// TODO: replace with backend pagination endpoint
			return { items: [] as Array<{ id: number; code: string }>, nextOffset: null as number | null };
		},
		initialPageParam: 0,
		getNextPageParam: lastPage => lastPage?.nextOffset ?? undefined,
		initialData: { pages: [], pageParams: [] },
		enabled: open
	});

	const items = useMemo(() => query.data?.pages.flatMap(p => p.items) ?? [], [query.data]);

	const { sentinelRef } = useInfinityScrollObserver({ hasNextPage: Boolean(query.hasNextPage), isFetching: query.isFetching, fetchNextPage: () => query.fetchNextPage() });

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>Vybrat paletu</DialogTitle>
				</DialogHeader>
				<div className="space-y-2">
					<Input placeholder="Hledat..." value={filter} onChange={e => setFilter(e.target.value)} />
					<div className="max-h-64 overflow-auto border rounded">
						{items.map(hu => (
							<button key={hu.id} className="w-full text-left px-3 py-2 hover:bg-muted/50" onClick={() => onSelect(hu)}>
								{hu.code}
							</button>
						))}
						<div ref={sentinelRef} />
					</div>
				</div>
				<DialogFooter>
					<Button variant="outline" onClick={() => onOpenChange(false)}>
						Zavřít
					</Button>
					{query.hasNextPage && (
						<Button onClick={() => query.fetchNextPage()} disabled={query.isFetchingNextPage}>
							Načíst další
						</Button>
					)}
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}
